// extracted by mini-css-extract-plugin
export default {"teaser":"leaf-category-page__teaser__IVaRs"};